
import { TripLog } from '@clients/myTrips';
import SetupStep5 from '@components/vehicle-setup/steps/SetupStep5.vue';
import { RouterFrom } from '@router/Routes';
import goBackWithFallback from '@util/goBackWithFallback';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Location as RouterLocation } from 'vue-router/types/router';
import { namespace } from 'vuex-class';

const TriplogModule = namespace('Triplog');
const RouterModule = namespace('Router');

@Component({
  name: 'InstallationGuide',
  components: {
    SetupStep5
  }
})
export default class InstallationGuide extends Vue {
  @TriplogModule.Getter('getSelectedTriplog')
  private selectedTriplog: TripLog;

  @RouterModule.State('from')
  private from: RouterFrom;

  created() {
    if (!this.selectedTriplog) {
      this.close();
    }
  }

  get backLocation(): RouterLocation {
    return { name: 'informationOverview' };
  }

  private close() {
    goBackWithFallback(this.$router, !!this.from.name, this.backLocation);
  }
}
